export enum ViewColumnsAddRowBlock {
  Root = 'ViewColumnsAddRow',
}

export enum ViewColumnsAddRowElement {
  Title = 'title',
  Content = 'content',
}
